export class JobProgressStepDatabaseCopyCreationData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "instanceClass",
            "baseName": "instanceClass",
            "type": "string",
            "format": ""
        },
        {
            "name": "instanceClassOverride",
            "baseName": "instanceClassOverride",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "engineVersion",
            "baseName": "engineVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "allocatedStorageGib",
            "baseName": "allocatedStorageGib",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "engine",
            "baseName": "engine",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepDatabaseCopyCreationData.attributeTypeMap;
    }
    constructor() {
    }
}
